export default "__VITE_PUBLIC_ASSET__e6f1f375__"